export const KEYS = {
  PSEUDO_ID: 'pseudo-id',
  SESSION_ID: 'session-id',
} as const

// PGSQL index limit ref: https://dba.stackexchange.com/questions/69161/character-varying-index-overhead-length-limit
// max limit 2704 - userId length 9 - b-tree index overhead 24
export const MAX_PATH_LENGTH = 2671
